import React from "react";

const coloproctology_content = [
  {
    label: "Organschaften",
    value: "organschaften",
    content: (
      <div>
        <p>
          Die interdisziplinäre deutschsprachige{" "}
          <strong>Zeitschrift coloproctology</strong> ist für alle proktologisch
          tätigen Ärzte zur Fort- und Weiterbildung unentbehrlich. Die
          Zeitschrift deckt das gesamte Spektrum der{" "}
          <strong>Koloproktologie</strong> ab und bietet Beiträge der folgenden
          Rubriken:
        </p>
        <ul>
          <li> Originalarbeiten </li> <li> Übersichten </li>
          <li> Kasuistiken </li>
          <li> CME · Zertifizierte Fortbildung </li>
          <li>
            Journal Club
            <br /> Kommentierte Zusammenfassungen aktueller internationaler
            Studien.
          </li>
          <li>
            Update
            <br /> Die auf der jährlichen Koloproktologie UPDATE-Veranstaltung
            diskutierten internationalen Publikationen werden jeweils unter
            einem Themenschwerpunkt zusammengefasst und von Experten
            kommentiert.
          </li>
          <li> Mitteilungen der Fachgesellschaften </li>
        </ul>
      </div>
    ),
  },
  // {
  //   label: "Sonderkonditionen für Mitglieder",
  //   value: "sonderkonditionen",
  //   content: (
  //     <div>
  //       <p>
  //         Mitglieder von DGK oder BCD erhalten attraktive Sonderkonditionen: Sie
  //         erhalten die 6 Ausgaben jährlich zum Sonderpreis von 69 EUR (statt 289
  //         EUR) in 2025 inkl. gesetzlicher MwSt. zzgl. Versandkosten (Inland 30 €
  //         | Ausland 49 €). Das Abonnement ist nach Ablauf der Mindestlaufzeit
  //         von einem Jahr jederzeit mit einer Frist von einem Monat kündbar.
  //         Preisänderungen und Irrtümer vorbehalten.
  //       </p>
  //     </div>
  //   ),
  // },
  {
    label: "Erscheinungsweise",
    value: "erscheinungsweise",
    content: (
      <div>
        <p>Die Zeitschrift erscheint 6 mal jährlich.</p>
      </div>
    ),
  },
  {
    label: "Online Zusatzangebot",
    value: "online_zusatzangebot",
    content: (
      <div>
        <p>
          {" "}
          coloproctology ist auch erhältlich im Rahmen von e.Med - dem
          Online-Paket von Springer Medizin. Sie erhalten coloproctology wie
          gewohnt als gedrucktes Heft und können zudem in den Volltexten von 80
          deutschen und 550 englischsprachigen medizinischen Fachzeitschriften
          recherchieren und mehr als 600 zertifizierte CME-Kurse für Ihre
          persönliche Fortbildung nutzen. <br /> Sie können e.Med kostenlos und
          unverbindlich testen unter:{" "}
          <a
            href="https://www.springermedizin.de/53e-coloproctoloy/7484174?itemUrl=/innere-medizin/products-innere-medizin/10048152"
            target="_blank"
            rel="noreferrer"
          >
            www.springermedizin.de
          </a>{" "}
        </p>
      </div>
    ),
  },
];

export default coloproctology_content;
